import React from 'react';
import _ from 'lodash';
import ImageIcon from '@mui/icons-material/Image';
import { Avatar, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const config = require('../../../../config');

interface Props {
  lenderWaterfallResult: any;
}

export const LenderInfo = ({ lenderWaterfallResult }: Props) => {
  const lenderProfiles = useSelector((state: any) => state.lp);
  const disabledLenderProfiles = useSelector((state: any) => state.disabledLenderProfiles);

  const avatarLink = `https://${config.S3_BUCKET_NAME}.s3-us-west-2.amazonaws.com/${_.get(
    lenderWaterfallResult,
    'runtimeOutput.event.params.lenderProfile.logo'
  )}`;

  const lenderName =
    [...lenderProfiles, ...disabledLenderProfiles].find(lp => lp.id === lenderWaterfallResult.lenderProfileId)
      ?.lenderAccount?.name || lenderWaterfallResult.runtimeOutput?.event?.params?.lenderProfile?.name;

  return (
    <>
      <Avatar style={{ display: 'inline-flex' }} alt="img" src={avatarLink}>
        <ImageIcon textRendering={lenderWaterfallResult.lender} />
      </Avatar>

      <Typography component="span" variant="body2">
        {lenderName}
      </Typography>
    </>
  );
};
